<template>
  <img
    :src="require(`@/assets/images/${name}.svg`)"
    :alt="name"
    :class="className"
    :width="width"
  />
</template>

<script>
export default {
  name: "VIcon",
  props: {
    name: String,
    className: String,
    width: String
  }
};
</script>

<style lang="scss" scoped></style>
